export default "__VITE_ASSET__040d3319__"